const territory1 = ['PA', 'IL', 'ON', 'VA'];
const territory2 = ['TX', 'GA', 'AB', 'NY'];
const territory3 = ['FL', 'CA', 'BC', 'AZ'];
const smallBusiness = ['1-20'];
const medBusiness = ['21-50', 'None Right Now'];
const largeBusiness = ['51-75', '76-100', '101-150', '151-400'];

const regions = [
  // { key: 'ITAAE-1', link: 'https://calendly.com/lillio-itaae-1/lillio-demonstration', territory: territory1, size: smallBusiness},
  // { key: 'ITAAE-2', link: 'https://calendly.com/lillio-itaae-2/lillio-demonstration', territory: territory2, size: smallBusiness},
  // { key: 'ITAAE-3', link: 'https://calendly.com/lillio-itaae-3/lillio-demonstration', territory: territory3, size: smallBusiness},
  // { key: 'ITAE-1', link: 'https://calendly.com/lillio-team-1/lillio-demonstration', territory: territory1, size: medBusiness},
  // { key: 'ITAE-2', link: 'https://calendly.com/lillio-team-2/lillio-demonstration', territory: territory2, size: medBusiness},
  // { key: 'ITAE-3', link: 'https://calendly.com/lillio-team-3/lillio-demonstration', territory: territory3, size: medBusiness},
  // { key: 'ITSAE-1', link: 'https://calendly.com/lillio-itsae-1/lillio-demonstration', territory: territory1, size: largeBusiness},
  // { key: 'ITSAE-2', link: 'https://calendly.com/lillio-itsae-2/lillio-demonstration', territory: territory2, size: largeBusiness},
  // { key: 'ITSAE-3', link: 'https://calendly.com/lillio-itsae-3/lillio-demonstration', territory: territory3, size: largeBusiness},
  { key: 'OOTAAE', link: 'https://calendly.com/lillio-group-demo/lillio-demonstration', territory: [], size: smallBusiness},
  { key: 'OOTAE', link: 'https://calendly.com/lillio-demo/lillio-demonstration', territory: [], size: medBusiness},
  { key: 'OOTSAE', link: 'https://calendly.com/lillio-demo/lillio-custom-demonstration-51', territory: [], size: largeBusiness},
];

const statePrefixes = [
  { key: 'Pennsylvania', value: 'PA' },
  { key: 'Illinois', value: 'IL' },
  { key: 'Ontario', value: 'ON' },
  { key: 'Virginia', value: 'VA' },
  { key: 'Texas', value: 'TX' },
  { key: 'Georgia', value: 'GA' },
  { key: 'Alberta', value: 'AB' },
  { key: 'New York', value: 'NY' },
  { key: 'Florida', value: 'FL' },
  { key: 'California', value: 'CA' },
  { key: 'British Columbia', value: 'BC' },
  { key: 'Arizona', value: 'AZ' }
]

export const getSalesCalendlyLink = ( data, title ) => {
  if (data?.stateProvince === 'International') {
    return {link: 'https://calendly.com/book-tour/tour'};
  }
  const prefix = statePrefixes.find(x => x.key === data?.stateProvince)?.value;
  const enrollment = title === 'Home Daycare Provider' ? '1-20' : data?.enrollmentRange;
  const filterRegionBySize = regions.filter(x => x.size?.some(y => y === enrollment));
  const filterByTerritory = filterRegionBySize.find(x => x.territory?.some(y => y === prefix) || x.territory?.length === 0);
  return filterByTerritory;
}
